module.exports = "../../static/img/templateimg.9b5ff81.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/templateimg.png
// module id = 1134
// module chunks = 1